module.exports = __webpack_public_path__ + "static/flags/AO-38d3b3c69db8838a527f8e088e398dee.gif";